var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysTag = function SvgSysTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    clipPath: "url(#sysTag_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.643 7.146-1.348 1.35a1.01 1.01 0 0 0 0 1.426l4.283 4.284a1.01 1.01 0 0 0 1.427 0l1.348-1.348-5.71-5.712ZM13.668 3.75a1 1 0 0 0-.923-.923l-3.96-.323a1.006 1.006 0 0 0-.8.292L3.64 7.14l5.71 5.71 4.343-4.345a1.007 1.007 0 0 0 .292-.8l-.318-3.956Zm-2.674 3.064h-.1a1.265 1.265 0 1 1 .1 0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sysTag_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h16v16H0z"
  })))));
};
export default SvgSysTag;